// Lesson page preview, remove links
App.lessonPreview = {
	initialize: function(){
		if ( $('.onLessonsPreviewView').length == 0 ) return;
		$('#footerInternal').find('.leftLinks a').removeAttr('href').addClass('inactive').css('color','#9F9F9F').css('cursor','text');
	}
};
// end Lesson page preview
